"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGBarChart = void 0;
const react_1 = __importDefault(require("react"));
const bar_1 = require("@nivo/bar");
const lodash_1 = require("lodash");
const TGBarChart = (props) => {
    const { layout, indexBy, groupMode } = props;
    return (react_1.default.createElement(bar_1.ResponsiveBar, Object.assign({}, props, { margin: { top: 50, right: 130, bottom: 50, left: 60 }, padding: 0.3, valueScale: { type: 'linear', nice: true }, indexScale: { type: 'band', round: true }, label: (datum) => datum.value ? `${lodash_1.floor(datum.value, 2)}` : datum.formattedValue, colors: { scheme: 'nivo' }, borderColor: {
            from: 'color',
            modifiers: [['darker', 1.6]],
        }, axisTop: null, axisRight: null, axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -20,
            truncateTickAt: 0,
        }, axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            truncateTickAt: 0,
        }, labelSkipWidth: 12, labelSkipHeight: 12, labelTextColor: {
            from: 'color',
            modifiers: [['darker', 1.6]],
        }, legends: [
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1,
                        },
                    },
                ],
            },
        ], ariaLabel: `${groupMode !== null && groupMode !== void 0 ? groupMode : 'stacked'} ${layout !== null && layout !== void 0 ? layout : 'vertical'} bar chart${indexBy ? ` indexed by ${indexBy}` : ''}`, barAriaLabel: (datum) => `${datum.id}: ${datum.formattedValue}${indexBy ? ` in ${indexBy}: ${datum.indexValue}` : ''}` })));
};
exports.TGBarChart = TGBarChart;
exports.default = exports.TGBarChart;
//# sourceMappingURL=TGBarChart.js.map